intra_module.factory('Term', function($resource, api_url) {
    const url    = `${api_url}/promo/:name`;
    const params =
        {name: '@name'};
    const actions = {
        getMarks: {
            url: `${api_url}/terms/:term/students/:login/marks`,
            method: 'GET',
            params: {
                term:  '@term',
                login: '@login'
            },
            isArray: true
        },

        getUnreadForTermsWall: {
            method:  'GET',
            url:     `${api_url}/terms/unread_conversations`,
            isArray: false
        },

        getPreviousTerms: {
            method:  'GET',
            url:     `${api_url}/promo/archives`,
            isArray: true
        },

        getMyPromo: {
            method:  'GET',
            url:     `${api_url}/my_promo`,
            isArray: false
        }
    };

    return $resource(url, params, actions);
});
